const throttleToNextFrame = <F extends (...args: unknown[]) => void>(
  fn: F,
): ((...funcArgs: Parameters<F>) => void) & {
  cancel: () => void;
} => {
  let frameReference: number;
  let throttlePause = false;

  const cancel = (): void => {
    cancelAnimationFrame(frameReference);
  };

  return Object.assign(
    (...args: Parameters<F>): void => {
      if (throttlePause) {
        return;
      }

      throttlePause = true;
      frameReference = requestAnimationFrame((): void => {
        throttlePause = false;

        fn(...args);
      });
    },
    { cancel },
  );
};

export default throttleToNextFrame;
